import { z } from 'zod';

export enum HumanTaskPrimitiveConditionOperation {
  IsNullish = 'IsNullish',
  IsDefined = 'IsDefined',
  IsTruthy = 'IsTruthy',
  IsFalsy = 'IsFalsy',
}
export const HumanTaskPrimitiveConditionSchema = z.object({
  operation: z.enum(HumanTaskPrimitiveConditionOperation),
  fieldName: z.string(),
});
export type HumanTaskPrimitiveCondition = z.infer<typeof HumanTaskPrimitiveConditionSchema>;

export enum HumanTaskValueConditionOperation {
  EqualsIgnoreCase = 'EqualsIgnoreCase',
  NotEqualsIgnoreCase = 'NotEqualsIgnoreCase',
}
export const HumanTaskValueConditionSchema = z.object({
  operation: z.enum(HumanTaskValueConditionOperation),
  fieldName: z.string(),
  value: z.string(),
});
export type HumanTaskValueCondition = z.infer<typeof HumanTaskValueConditionSchema>;

export enum HumanTaskArrayConditionOperation {
  IsOneOf = 'IsOneOf',
  IsNotOneOf = 'IsNotOneOf',
}
export const HumanTaskArrayConditionSchema = z.object({
  operation: z.enum(HumanTaskArrayConditionOperation),
  fieldName: z.string(),
  values: z.array(z.string()),
});
export type HumanTaskArrayCondition = z.infer<typeof HumanTaskArrayConditionSchema>;

export const HumanTaskConditionSchema = z.discriminatedUnion('operation', [
  HumanTaskPrimitiveConditionSchema,
  HumanTaskValueConditionSchema,
  HumanTaskArrayConditionSchema,
]);
export type HumanTaskCondition = z.infer<typeof HumanTaskConditionSchema>;

export function isHumanTaskValueCondition(
  condition: HumanTaskCondition
): condition is HumanTaskValueCondition {
  return 'value' in condition;
}

export function isHumanTaskArrayCondition(
  condition: HumanTaskCondition
): condition is HumanTaskArrayCondition {
  return 'values' in condition;
}

export function isHumanTaskPrimitiveCondition(
  condition: HumanTaskCondition
): condition is HumanTaskPrimitiveCondition {
  return !isHumanTaskValueCondition(condition) && !isHumanTaskArrayCondition(condition);
}
